import { useSelector, useDispatch } from 'react-redux';
import { createProject, getProjectPmsList, showAddProject } from '../../../actions/project';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { actualValueForDropdown, debounce, validateNumberValue } from '../../../utils/common';
import Form from '../../../common/Form';
import Input from '../../../common/Form/Input';
import Select from '../../../common/Form/Select';
import { useForm } from 'react-hook-form';
import Radio from '../../../common/Form/Radio';
import Upload from '../../../common/Form/FileUpload';
import { closeModalAction, openCustomModal } from '../../../actions/modal';
import ButtonScogoPrimary from '../../../common/Buttons/ButtonScogoPrimary';
import ButtonScogoClosedOutlined from '../../../common/Buttons/ButtonScogoClosedOutlined';
import OverflowTip from '../../../common/OverflowTip';
import { textCss } from '../../../common/Css';
import CheckListToProject, { formTableName } from '../Modals/CheckListToProject';
import { getList } from '../Modals/EditPM';
import { postImageUrl } from '../../../actions/users';
import { useNavigate } from 'react-router-dom';
import React, { useRef } from 'react';
import Customer from '../../../components/Inputs/Customer';
import Teams from '../../../components/Inputs/Teams';
import Tags from '../../../components/Inputs/Tags';
import Enduser from '../../../components/Inputs/Enduser';
import RenderContact from '../../../components/Inputs/Contact';
import { convertIntoPaisa } from '../../../utils/utils';
import { getDefultMilestone } from '../../../actions/admin';
import { canManageOtherOrgs } from '../../../utils/access';

const radioOptions = [
    { value: 0, name: 'first', label: 'No' },
    { value: 1, name: 'first', label: 'Yes' },
];

const radioOptions2 = [
    { value: 0, name: 'second', label: 'No' },
    { value: 1, name: 'second', label: 'Yes' },
];

const radioOptionsProjectOwner = [
    { value: 0, name: 'first', label: 'No' },
    { value: 1, name: 'first', label: 'Yes' },
];

export const radioOptionsBearer = [
    { value: 'CUSTOMER', name: 'bearer', label: 'Customer' },
    { value: 'SCOGO', name: 'bearer', label: 'Scogo' },
];

export const chargeTypes = [
    { key: 'SERVICE', label: 'Service' },
    { key: 'TRAVEL', label: 'Travel' },
    { key: 'MATERIAL', label: 'Material' },
    { key: 'COURIER', label: 'Courier' },
    // { key: 'INCENTIVE', label: 'Incentive' },
    // { key: 'GST', label: 'GST' },
    // { key: 'OVERTIME', label: 'Overtime' },
];

export const billingTypes = [
    { key: 'MONTHLY', label: 'MONTHLY', value: 'MONTHLY' },
    { key: 'QUARTERLY', label: 'QUARTERLY', value: 'QUARTERLY' },
    { key: 'HALF_YEARLY', label: 'HALF_YEARLY', value: 'HALF_YEARLY' },
    { key: 'YEARLY', label: 'YEARLY', value: 'YEARLY' },
];

export const categoryDropdownList = [
    { value: 'NETWORK_ROLLOUT', key: 'NETWORK_ROLLOUT', label: "Networks Rollout" },
    { value: 'RMA', key: 'RMA', label: "RMA" },
    { value: 'HELPDESK', key: 'HELPDESK', label: "HelpDesk" },
    { value: 'INFRA', key: 'INFRA', label: "Infra" },
    { value: 'ISP', key: 'ISP', label: "ISP" },
    { value: 'IWAN', key: 'IWAN', label: "Iwan" },
    { value: 'STAFFING', key: 'STAFFING', label: "Staffing" },
    { value: 'SUBSCRIPTION', key: 'SUBSCRIPTION', label: "Subscription" },
    { value: 'ADMINISTRATION', key: 'ADMINISTRATION', label: "Administration" },
    { value: 'ADVANCE_NETWORK', key: 'ADVANCE_NETWORK', label: "Advance Network" },
    { value: 'REPAIR', key: 'REPAIR', label: "Repair" },
    { value: 'TELECOM', key: 'TELECOM', label: "Telecom" },
    { value: 'PREVENTIVE_MAINTAINANCE', key: 'PREVENTIVE_MAINTAINANCE', label: "Preventive Maintainance" },
    { value: 'LOGISTICS', key: 'LOGISTICS', label: "Logistics" },
    { value: 'STAGING', key: 'STAGING', label: "Staging" },
    { value: 'DC', key: 'DC', label: "DC" },
];

const formName = 'addProjectCustomerForm';

export default function AddProjectForm(props) {
    const dispatch = useDispatch();
    const [showTemplate, setShowTemplate] = useState(false);
    const projectId = useSelector((state) => state.project.preCreatedProjectId);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData)
    const dealList = useSelector((state) => state.project.dealList);
    const [formValuesMS, setFormValuesMS] = useState({})
    const [sendProjectId, setSendProjectId] = useState(false);
    const isScogoDealIdsLoading = useSelector((state) => state.loading.isScogoDealIdsLoading);
    const isServiceListLoading = useSelector((state) => state.loading.isServiceListLoading);
    const inviteFormImagesUrls = useSelector((state) => state.user.inviteFormImagesUrls);
    const eligiblePms = useSelector((state) => state.project.eligiblePms);
    const isUserListLoading = useSelector((state) => state.loading.isUserListLoading);
    const defaultValues = {
        is_asset_config_required: radioOptions[0].value,
        customer_sign_off: radioOptions2[0].value,
        bearer_SERVICE: 'CUSTOMER',
        bearer_TRAVEL: 'CUSTOMER',
        bearer_MATERIAL: 'CUSTOMER',
        bearer_COURIER: 'CUSTOMER',
        bearer_INCENTIVE: 'CUSTOMER',
        bearer_GST: 'CUSTOMER',
        bearer_OVERTIME: 'CUSTOMER'
    };
    const defaultMilestones = useSelector((state) => state.admin.defaultMilestones);
    const [additionalPoCount, setAdditionalPoCount] = useState(0);
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(getDefultMilestone());
    }, [dispatch]);

    const memoizedDefaultMilestones = useMemo(() => {
        let o = [];
        defaultMilestones?.forEach((milestone) => {
            o.push({
                key: milestone.id,
                value: milestone.type,
                label: milestone.type
            })
        })
        return o;
    }, [defaultMilestones])


    const fetchTemplate = (name) => {
        dispatch(
            openCustomModal({
                heading: `${name}`,
                modalWidth: '80rem',
                modalHeight: 'auto',
                showClose: false,
                modalComponent: <CheckListToProject setShowTemplate={setShowTemplate} setFormValuesMS={setFormValuesMS} formValuesMS={formValuesMS} name={name} onCancel={() => {
                    setValue('mile_stone_type', null)
                }} />,
            })
        )
    };

    const onCancel = () => {
        dispatch(showAddProject(false));
    };
    const methods = useForm({ defaultValues, mode: 'all' });
    const { watch, setValue } = methods;
    const fk_customer_id = watch('fk_customer_id');

    const onSubmit = (form) => {

        let sowUrl = inviteFormImagesUrls.sow ? inviteFormImagesUrls.sow : '';
        let signOffTemplate = inviteFormImagesUrls.Sign_Off_Report ? inviteFormImagesUrls.Sign_Off_Report : '';

        let MS = {
            ...formValuesMS?.defaultData,
            title: "Milestone1",
            order: 1,
            type: form.mile_stone_type.value,
            tasks: formValuesMS?.[formTableName].map((item) => {
                let data = {
                    title: item.title,
                    is_file_required: false,
                    input_type: actualValueForDropdown(item.input_type),
                }

                if (item.options && item.options.length > 0) {
                    data.options = item.options;
                }
                return data;
            }),
            cost: {}
        };

        let contact = {};
        if (actualValueForDropdown(form?.project_contact_person) === 'add-new-contact') {
            contact = {
                name: form[`project_contact_person:name`],
                email: form[`project_contact_person:email`],
                mobile: form[`project_contact_person:mobile`]
            }
        } else if (form.project_contact_person) {
            contact = {
                id: form.project_contact_person.id,
                name: form.project_contact_person.name,
                email: form.project_contact_person.email,
                mobile: form.project_contact_person.mobile
            };
        }

        let payments = {
            SP_SERVICE: convertIntoPaisa(form.SP_SERVICE),
            CLUSTER_INCENTIVE: convertIntoPaisa(form.CLUSTER_INCENTIVE),
            PSP_INCENTIVE: convertIntoPaisa(form.PSP_INCENTIVE)
        }

        let projectForm = {
            name: form.project_name,
            category: actualValueForDropdown(form.category).toUpperCase(),
            desc: form.project_description,
            contact_person: contact,
            milestones: [MS],
            tag_ids: form.tags ? form.tags.map((item) => item.value) : [],
            is_customer_sign_off_required: form.customer_sign_off === 1 ? true : false,
            is_asset_config_required: form.is_asset_config_required === 1 ? true : false,
            team_ids: form?.teams?.map((item) => item.value),
            sow: sowUrl ? sowUrl : undefined,
            sign_off_template: signOffTemplate ? signOffTemplate : undefined,
            org_id: actualValueForDropdown(form.fk_customer_id),
            customer_cost: form.customer_cost ? convertIntoPaisa(form.customer_cost) : 0,
            payment_terms: form.payment_terms ? validateNumberValue(form.payment_terms) : 0,
            payments: Object.keys(payments).length > 0 ? payments : undefined,
        };

        if (canManageCustomer) {
            projectForm.payments = Object.keys(payments).length > 0 ? payments : undefined;
            projectForm.customer_cost = convertIntoPaisa(form.customer_cost);
            projectForm.payment_terms = validateNumberValue(form.payment_terms);

            // Project managers
            let project_managers = [];
            if (form.first_pm_id) {
                project_managers.push({
                    user_id: actualValueForDropdown(form.first_pm_id),
                    role: 'PM1'
                })
            }
            if (form.second_pm_id) {
                project_managers.push({
                    user_id: actualValueForDropdown(form.second_pm_id),
                    role: 'PM2'
                })
            }
            if (form.third_pm_id) {
                project_managers.push({
                    user_id: actualValueForDropdown(form.third_pm_id),
                    role: 'PM3'
                })
            }
            if (form.escalate_manager) {
                project_managers.push({
                    user_id: actualValueForDropdown(form.escalate_manager),
                    role: 'EM'
                })
            }

            projectForm.project_managers = project_managers;

            // Purchase orders
            let purchase_orders = [];
            for (let i = 0; i <= additionalPoCount; i++) {
                const currentFile = inviteFormImagesUrls[`purchase_orders[${i}].po_file`] ? inviteFormImagesUrls[`purchase_orders[${i}].po_file`] : '';
                if (form.purchase_orders[i].po_number || form.purchase_orders[i].po_amount || form.purchase_orders[i].po_file) {
                    let additionalPO = { currency: 'INR' };
                    if (form.purchase_orders[i].po_number) additionalPO.po_number = form.purchase_orders[i].po_number;
                    if (form.purchase_orders[i].po_amount) additionalPO.amount = convertIntoPaisa(form.purchase_orders[i].po_amount);
                    if (currentFile) additionalPO.attachments = [currentFile];
                    if (form.purchase_orders[i].start_date) additionalPO.start_date = form.purchase_orders[i].start_date;
                    if (form.purchase_orders[i].end_date) additionalPO.end_date = form.purchase_orders[i].end_date;
                    purchase_orders.push(additionalPO);
                }
            }

            projectForm.purchase_orders = purchase_orders;


            // Additional cost bearers
            let additional_cost_bearers = [];
            chargeTypes.forEach((charge) => {
                additional_cost_bearers.push({
                    category: charge.key,
                    bearer: form[`bearer_${charge.key}`]
                })
            });

            if (additional_cost_bearers.length > 0) {
                projectForm.additional_cost_bearers = additional_cost_bearers;
            }

            // Budget
            if (form.per_ticket_budget_in_paisa) projectForm.per_ticket_budget_in_paisa = convertIntoPaisa(form.per_ticket_budget_in_paisa);
            if (form.fault_rate) projectForm.fault_rate = validateNumberValue(form.fault_rate);
            if (form.budget_in_paisa) projectForm.budget_in_paisa = convertIntoPaisa(form.budget_in_paisa);
            if (form.max_tickets_allowed) projectForm.max_tickets_allowed = validateNumberValue(form.max_tickets_allowed);
            if (form.billing_type) projectForm.period = actualValueForDropdown(form.billing_type);
            if (form.upper_limit) projectForm.upper_limit = validateNumberValue(form.upper_limit);
        }


        if (actualValueForDropdown(form.enduser_id) && actualValueForDropdown(form.enduser_id) !== 'add-new-enduser') {
            projectForm.end_user_id = actualValueForDropdown(form.enduser_id);
        }
        if (actualValueForDropdown(form.enduser_id) === 'add-new-enduser') {
            projectForm.create_end_user = form[`enduser_id:new`]
        }
        if (sendProjectId) {
            projectForm.id = projectId;
        };

        dispatch(createProject({ projectForm: projectForm, formName, navigate, orgId: actualValueForDropdown(form.fk_customer_id) }));
    };

    const onFileUpload = (files, ref) => {
        let additionalData = {}
        if (projectId) {
            additionalData = { project_id: projectId }
        } else {
            additionalData = { create: true }
        }
        let purpose
        if (ref === 'sow') {
            purpose = 'PROJECT_SOW'
        } else if (ref === 'Sign_Off_Report') {
            purpose = 'PROJECT_SIGNOFF_TEMPLATE'
        } else if (ref.startsWith('purchase_orders')) {
            purpose = 'PROJECT_PO'
        }
        dispatch(postImageUrl({ files, type: 'kyc', ref, purpose: purpose, additionalData: additionalData }));
        setSendProjectId(true)
    }

    const submitRef = useRef(null);

    const getPmList = useCallback(({ limit, page, query, org_id }) => {
        dispatch(getProjectPmsList({ can_manage_projects: true, limit, page, query, org_id }))
    }, [dispatch]);

    const debouncedGetPmList = useCallback(debounce(getPmList), []);

    const project_manager_1 = watch('first_pm_id');
    const project_manager_2 = watch('second_pm_id');
    const project_manager_3 = watch('third_pm_id');
    const isSelectedCategoryIsRmaOrHelpdesk = ['RMA', 'HELPDESK'].includes(actualValueForDropdown(watch('category')));

    const customerPrice = watch('customer_cost') || 0;
    const vendorPrice = watch('SP_SERVICE') || 0;
    const clusterIncentive = watch('CLUSTER_INCENTIVE') || 0;
    const pspIncentive = watch('PSP_INCENTIVE') || 0;

    // Watch values for conditional validation
    const faultRateValue = watch('fault_rate');
    const numberOfTicketsValue = watch('number_of_tickets');

    const calculatedCost = useMemo(() => {
        return Number(vendorPrice) + Number(clusterIncentive) + Number(pspIncentive);
    }, [vendorPrice, clusterIncentive, pspIncentive]);

    const calculatedProfit = useMemo(() => {
        return Number(customerPrice) - calculatedCost;
    }, [customerPrice, calculatedCost]);

    const calculatedProfitPercentage = useMemo(() => {
        if (Number(customerPrice) === 0) return 0;
        return ((calculatedProfit / Number(customerPrice)) * 100).toFixed(2);
    }, [customerPrice, calculatedProfit]);

    const canManageCustomer = canManageOtherOrgs(newLoggedUserData?.actions);

    useEffect(() => {
        if (!canManageCustomer) {
            methods.setValue('fk_customer_id', newLoggedUserData?.org?.id);
        }
    }, [canManageCustomer, methods, newLoggedUserData?.org?.id]);

    useEffect(() => {
        if (canManageCustomer) {
            getPmList({ limit: 100, page: 1, query: '' })
        }
    }, [canManageCustomer]);

    return (
        <Form
            methods={methods}
            className='overflow-hidden h-full'
            onSubmit={(e) => {
                onSubmit(e);
            }}
            submitRef={submitRef}
        >
            <div className='flex-auto gap-4 overflow-y-auto max-h-[calc(100%-60px)] bg-gray-50'>
                {/* Quick Settings */}
                <div className='bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-2 mb-3 border border-blue-200 shadow-sm flex items-center'>
                    <div className='flex items-center gap-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-scogoprimary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span className='font-semibold text-gray-700 text-lg'>Project Configuration:</span>
                    </div>
                    <div className='flex flex-col sm:flex-row gap-4 items-start sm:items-center'>
                        <Radio className='flex flex-row gap-2 items-center' name='customer_sign_off' label='Customer SignOff Required' id='customer_sign_off' options={radioOptionsProjectOwner} />
                        <Radio className='flex flex-row gap-2 items-center' name='is_asset_config_required' label='Asset Config Required' id='is_asset_config_required' options={radioOptions} />
                    </div>
                </div>

                {/* Project Details Card */}
                <div className='bg-white rounded-xl shadow-lg p-3 mb-3 border border-gray-200 hover:shadow-xl transition-shadow duration-300'>
                    <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-scogoprimary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <div>
                            <h3 className="font-bold text-lg text-gray-800">Project Details</h3>
                            <p className="text-xs text-gray-500">Basic information about your project</p>
                        </div>
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
                        <Input label='Name' name='project_name' required placeholder='Enter project name' />
                        <Input label='Description' name='project_description' required />
                        {canManageCustomer && <Customer label='Customer' name='fk_customer_id' required />}
                        <Enduser label='Enduser' name='enduser_id' required org_id={actualValueForDropdown(fk_customer_id)} add_new={true} />
                        <RenderContact label='Contact Person' name='project_contact_person' required org_id={actualValueForDropdown(fk_customer_id)} />
                        <Select label='Category' name='category' options={categoryDropdownList} isLoading={false} required />
                        <Select label='Scogo Deal ID' name='deal_id' options={dealList} isLoading={isScogoDealIdsLoading} />
                        <Select
                            label='Milestone Type'
                            name='mile_stone_type'
                            options={memoizedDefaultMilestones}
                            required
                            isLoading={isServiceListLoading}
                            onChange={(selectedOption) => {
                                fetchTemplate(selectedOption.label);
                            }}
                        />
                    </div>
                </div>

                {/* Stakeholder Details Card */}
                {canManageCustomer ? <div className='bg-white rounded-xl shadow-lg p-6 mb-4 border border-gray-200 hover:shadow-xl transition-shadow duration-300'>
                    <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-scogoprimary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <div>
                            <h3 className="font-bold text-lg text-gray-800">Stakeholder Details</h3>
                            <p className="text-xs text-gray-500">Assign project managers and escalation manager</p>
                        </div>
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
                        <Select onInputChange={(event) => {
                            if (event.length > 0) {
                                debouncedGetPmList({ query: event, limit: 100, page: 1 })
                            }
                        }} isLoading={isUserListLoading} label='PM 1' name='first_pm_id' options={getList(eligiblePms, project_manager_2, project_manager_3)} />
                        <Select onInputChange={(event) => {
                            if (event.length > 0) {
                                debouncedGetPmList({ query: event, limit: 100, page: 1 })
                            }
                        }} isLoading={isUserListLoading} label='PM 2' name='second_pm_id' options={getList(eligiblePms, project_manager_1, project_manager_3)} readOnly={!project_manager_1} />
                        <Select onInputChange={(event) => {
                            if (event.length > 0) {
                                debouncedGetPmList({ query: event, limit: 100, page: 1 })
                            }
                        }} isLoading={isUserListLoading} label='PM 3' name='third_pm_id' options={getList(eligiblePms, project_manager_1, project_manager_2)} readOnly={!project_manager_1 || !project_manager_2} />
                        <Select onInputChange={(event) => {
                            if (event.length > 0) {
                                debouncedGetPmList({ query: event, limit: 100, page: 1 })
                            }
                        }} isLoading={isUserListLoading} label='EM' name='escalate_manager' options={eligiblePms} />
                    </div>
                </div> : null}

                <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4'>
                    {/* Teams and Tags Card */}
                    <div className='bg-white rounded-xl shadow-lg p-6 border border-gray-200 hover:shadow-xl transition-shadow duration-300'>
                        <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200'>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-scogoprimary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                            <div>
                                <h3 className="font-bold text-lg text-gray-800">Teams & Tags</h3>
                                <p className="text-xs text-gray-500">Assign teams and define prerequisites</p>
                            </div>
                        </div>
                        <div className='flex gap-4'>
                            <Teams className='w-full' isMulti label='Teams' name='teams' required={true} org_id={actualValueForDropdown(fk_customer_id)} />
                            <Tags required={false} className='w-full' isMulti label='FE Prerequisite' name='tags' type='TOOL' org_id={actualValueForDropdown(fk_customer_id)} />
                        </div>
                    </div>

                    {/* Documents Card */}
                    <div className='bg-white rounded-xl shadow-lg p-6 border border-gray-200 hover:shadow-xl transition-shadow duration-300'>
                        <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200'>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-scogoprimary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            </svg>
                            <div>
                                <h3 className="font-bold text-lg text-gray-800">Documents</h3>
                                <p className="text-xs text-gray-500">Upload SOW and sign-off templates</p>
                            </div>
                        </div>
                        <div className='flex gap-4'>
                            <div className='bg-blue-50 rounded-lg border border-blue-200 w-full'>
                                <Upload
                                    id='sow'
                                    label='SOW (Statement of Work)'
                                    name='sow'
                                    onChange={e => onFileUpload(e, 'sow')}
                                    accept="image/jpeg,image/png,application/pdf"
                                    validateFileType={file => {
                                        const isAcceptedFileType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type);
                                        return isAcceptedFileType || `${file.name} is not an accepted file type`;
                                    }}
                                    className='w-full'
                                />
                                <span className='px-2 text-xs text-gray-600 py-1 block'>PDF, JPEG, or PNG format</span>
                            </div>
                            <div className='bg-green-50 rounded-lg border border-green-200 w-full'>
                                <Upload
                                    id='Sign_Off_Report'
                                    label='Sign Off Report Template'
                                    name='Sign_Off_Report'
                                    onChange={e => onFileUpload(e, 'Sign_Off_Report')}
                                    accept="image/jpeg,image/png,application/pdf"
                                    validateFileType={file => {
                                        const isAcceptedFileType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type);
                                        return isAcceptedFileType || `${file.name} is not an accepted file type`;
                                    }}
                                    className='w-full'
                                />
                                <span className='px-2 text-xs text-gray-600 py-1 block'>PDF, JPEG, or PNG format</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Incentives Card */}
                {canManageCustomer ? <div className='bg-white rounded-xl shadow-lg p-6 mb-4 border border-gray-200 hover:shadow-xl transition-shadow duration-300'>
                    <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200'>
                        <div>
                            <h3 className="font-bold text-lg text-gray-800">Per Ticket Pricing & Incentives</h3>
                            <p className="text-xs text-gray-500">Configure pricing, payment terms, and team incentives</p>
                        </div>
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
                        <Input placeholder='₹ 0.00' label='Charges To Customer' type='number' name='customer_cost' required step='any' />
                        <Input placeholder='₹ 0.00' label='Vendor Price' name='SP_SERVICE' required type='number' step='any' />
                        <Input placeholder='₹ 0.00' label='Cluster Lead Incentive' name='CLUSTER_INCENTIVE' type='number' required step='any' />
                        <Input placeholder='₹ 0.00' label='PSP Incentive' name='PSP_INCENTIVE' type='number' required step='any' />
                        <Input label='Payment Timeline' required name='payment_terms' type='number' />
                        <div className='bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-2 border-2 border-blue-300 shadow-sm'>
                            <div className='flex items-center gap-2 mb-2'>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                </svg>
                                <span className='text-sm font-medium text-gray-600'>Total Cost to SCOGO <span className='text-xs text-gray-500'>(Vendor + Incentives)</span></span>
                            </div>
                            <p className='text-2xl font-bold text-blue-700'>₹ {calculatedCost.toFixed(2)}</p>

                        </div>

                        <div className={`bg-gradient-to-br ${calculatedProfit >= 0 ? 'from-green-50 to-green-100 border-green-300' : 'from-red-50 to-red-100 border-red-300'} rounded-lg p-2 border-2 shadow-sm`}>
                            <div className='flex items-center gap-2 mb-2'>
                                <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${calculatedProfit >= 0 ? 'text-green-600' : 'text-red-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span className='text-sm font-medium text-gray-600'>Profit <span className='text-xs text-gray-500'>(Customer - Cost)</span></span>
                            </div>
                            <p className={`text-2xl font-bold ${calculatedProfit >= 0 ? 'text-green-700' : 'text-red-700'}`}>₹ {calculatedProfit.toFixed(2)}</p>
                        </div>

                        <div className={`bg-gradient-to-br ${calculatedProfit >= 0 ? 'from-purple-50 to-purple-100 border-purple-300' : 'from-orange-50 to-orange-100 border-orange-300'} rounded-lg p-2 border-2 shadow-sm`}>
                            <div className='flex items-center gap-2 mb-2'>
                                <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${calculatedProfit >= 0 ? 'text-purple-600' : 'text-orange-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                </svg>
                                <span className='text-sm font-medium text-gray-600'>Profit % <span className='text-xs text-gray-500'>(Profit / Customer) × 100</span></span>
                            </div>
                            <p className={`text-2xl font-bold ${calculatedProfit >= 0 ? 'text-purple-700' : 'text-orange-700'}`}>{calculatedProfitPercentage}%</p>
                        </div>
                    </div>
                </div> : null}

                {/* Budget Card */}
                {canManageCustomer ? <div className='bg-white rounded-xl shadow-lg p-6 mb-4 border border-gray-200 hover:shadow-xl transition-shadow duration-300'>
                    <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-scogoprimary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                        <div>
                            <h3 className="font-bold text-lg text-gray-800">Budget Planning</h3>
                            <p className="text-xs text-gray-500">Set project budget, per-ticket allocation, and projections</p>
                        </div>
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
                        <div className='relative'>
                            <Input label='Project Budget' type='number' name='budget_in_paisa' step='any' placeholder='₹ 0.00' />
                        </div>
                        <div className='relative'>
                            <Input label='Per Ticket Budget' type='number' name='per_ticket_budget_in_paisa' step='any' placeholder='₹ 0.00' />
                        </div>
                        {/* <div className='relative'>
                            <Input label='Projection' name='projection' placeholder='Enter projection value' />
                        </div> */}
                        {
                            isSelectedCategoryIsRmaOrHelpdesk ? (<>
                                <div className='relative'>
                                    <Input
                                        label='Number Of Tickets'
                                        name='max_tickets_allowed'
                                        placeholder='Enter number of tickets'
                                    />
                                </div>
                                <div className='relative'>
                                    <Input
                                        label='Fault Rate'
                                        name='fault_rate'
                                        placeholder='Enter fault rate value'
                                    />
                                </div>
                                <div className='relative'>
                                    <Input
                                        required={!!faultRateValue}
                                        label='Total no. of assets under AMC'
                                        name='upper_limit'
                                        placeholder='Enter total no. of assets under AMC value'
                                        validation={{
                                            validate: (value) => {
                                                if (faultRateValue && !value) {
                                                    return 'Total no. of assets under AMC is required when fault rate is provided';
                                                }
                                                return true;
                                            }
                                        }}
                                    />
                                </div>
                                <div className='relative'>
                                    <Select label='Billing Type' name='billing_type' options={billingTypes} />
                                </div>
                            </>) : null
                        }
                    </div>
                </div> : null}

                {/* Additional Charges Bearer Card */}
                {canManageCustomer ? <div className='bg-white rounded-xl shadow-lg p-6 mb-4 border border-gray-200 hover:shadow-xl transition-shadow duration-300'>
                    <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-scogoprimary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                        <div>
                            <h3 className="font-bold text-lg text-gray-800">Additional Charges Bearer</h3>
                            <p className="text-xs text-gray-500">Specify who bears the cost for each service type</p>
                        </div>
                    </div>
                    <div className='flex flex-wrap gap-4'>
                        {chargeTypes.map((charge) => (
                            <div key={charge.key} className='flex border-2 border-gray-300 rounded-lg p-4 bg-gradient-to-br from-gray-50 to-white hover:border-scogoprimary hover:shadow-md transition-all duration-200'>
                                <div className='flex items-center gap-2'>
                                    {charge.key === 'SERVICE' && <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>}
                                    {charge.key === 'TRAVEL' && <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>}
                                    {charge.key === 'MATERIAL' && <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>}
                                    {charge.key === 'COURIER' && <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" /></svg>}
                                    {charge.key === 'INCENTIVE' && <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" /></svg>}
                                    {charge.key === 'GST' && <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z" /></svg>}
                                    {charge.key === 'OVERTIME' && <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>}
                                    <span className='font-semibold text-sm text-gray-800'>{charge.label}</span>
                                </div>
                                <Radio
                                    className='flex gap-2'
                                    name={`bearer_${charge.key}`}
                                    id={`bearer_${charge.key}`}
                                    options={radioOptionsBearer.map(opt => ({ ...opt, name: `bearer_${charge.key}` }))}
                                />
                            </div>
                        ))}
                    </div>
                </div> : null}

                {/* PO Details Card */}
                {canManageCustomer ? <div className='bg-white rounded-xl shadow-lg p-6 mb-4 border border-gray-200 hover:shadow-xl transition-shadow duration-300'>
                    <div className='flex items-center gap-2 mb-4 pb-3 border-b border-gray-200'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-scogoprimary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <div>
                            <h3 className="font-bold text-lg text-gray-800">Purchase Order (PO) Details</h3>
                            <p className="text-xs text-gray-500">Manage purchase orders with dates and documentation</p>
                        </div>
                    </div>
                    <div className='flex flex-col gap-4 w-full'>
                        <div className='border-2 border-blue-300 rounded-lg p-5 bg-gradient-to-br from-blue-50 to-white relative'>
                            <div className='absolute top-2 left-2 bg-blue-600 text-white text-xs px-2 py-1 rounded-md font-semibold'>
                                PO #1
                            </div>
                            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-6'>
                                <Input className='w-full' label='PO Number' name='purchase_orders[0].po_number' placeholder='Enter PO number' />
                                <Input className='w-full' label='PO Amount' name='purchase_orders[0].po_amount' type='number' step='any' placeholder='Enter amount' />
                                <Input className='w-full' label='Start Date' name='purchase_orders[0].start_date' type='date' />
                                <Input className='w-full' label='End Date' name='purchase_orders[0].end_date' type='date' />
                                <Upload className='w-full'
                                    id='po_file_0'
                                    label='PO File'
                                    name='purchase_orders[0].po_file'
                                    onChange={e => onFileUpload(e, 'purchase_orders[0].po_file')}
                                    accept="image/jpeg,image/png,application/pdf"
                                    validateFileType={file => {
                                        const isAcceptedFileType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type);
                                        return isAcceptedFileType || `${file.name} is not an accepted file type`;
                                    }}
                                />
                            </div>
                        </div>

                        {Array.from({ length: additionalPoCount }).map((_, index) => (
                            <div key={index + 1} className='border-2 border-gray-300 rounded-lg p-5 bg-gradient-to-br from-gray-50 to-white relative hover:border-scogoprimary transition-all duration-200'>
                                <div className='absolute top-2 left-2 bg-gray-700 text-white text-xs px-2 py-1 rounded-md font-semibold'>
                                    PO #{index + 2}
                                </div>
                                <button
                                    type="button"
                                    className="absolute top-2 right-2 text-red-500 hover:text-red-700 transition-colors p-2 rounded-full hover:bg-red-100"
                                    onClick={() => {
                                        const newCount = additionalPoCount - 1;
                                        setAdditionalPoCount(newCount >= 0 ? newCount : 0);
                                    }}
                                    title="Delete this PO"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                </button>
                                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-6'>
                                    <Input className='w-full' label='PO Number' name={`purchase_orders[${index + 1}].po_number`} placeholder='Enter PO number' />
                                    <Input className='w-full' label='PO Amount' name={`purchase_orders[${index + 1}].po_amount`} type='number' step='any' placeholder='Enter amount' />
                                    <Input className='w-full' label='Start Date' name={`purchase_orders[${index + 1}].start_date`} type='date' />
                                    <Input className='w-full' label='End Date' name={`purchase_orders[${index + 1}].end_date`} type='date' />
                                    <Upload className='w-full'
                                        id={`po_file_${index + 1}`}
                                        label='PO File'
                                        name={`purchase_orders[${index + 1}].po_file`}
                                        onChange={e => onFileUpload(e, `purchase_orders[${index + 1}].po_file`)}
                                        accept="image/jpeg,image/png,application/pdf"
                                        validateFileType={file => {
                                            const isAcceptedFileType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type);
                                            return isAcceptedFileType || `${file.name} is not an accepted file type`;
                                        }}
                                    />
                                </div>
                            </div>
                        ))}

                        {/* Add More PO button */}
                        <div className='flex justify-end pt-2'>
                            <button
                                type="button"
                                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95"
                                onClick={() => setAdditionalPoCount(prev => prev + 1)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                                <span>Add More PO</span>
                            </button>
                        </div>
                    </div>
                </div> : null}
            </div>
            <div className='flex-none gap-4 mr-4 h-[65px] bg-white border-t-2 border-gray-200 shadow-lg'>
                <div className='flex gap-4 justify-start items-center h-full px-6'>
                    <ButtonScogoClosedOutlined disabled={formButtonLoading[formName]} textOrComponent='Cancel' type='button' onClick={onCancel} />
                    <ButtonScogoPrimary loading={formButtonLoading[formName]} onClick={() => submitRef.current?.click()} textOrComponent={'Create Project'} type='submit' />
                </div>
            </div>
        </Form>
    );
}
